
import { Component, Vue } from 'vue-property-decorator';
import { DocumentationModule } from '~/store/modules/documentation';

@Component
export default class Documentation extends Vue {

    get supportLinks() {
        return DocumentationModule.environmentLinks?.user;
    }

    get moderationLinks() {
        return DocumentationModule.environmentLinks?.moderator;
    }

}
